import { render, staticRenderFns } from "./FooterHome.vue?vue&type=template&id=0c20bdfa&scoped=true"
import script from "./FooterHome.vue?vue&type=script&lang=js"
export * from "./FooterHome.vue?vue&type=script&lang=js"
import style0 from "./FooterHome.vue?vue&type=style&index=0&id=0c20bdfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c20bdfa",
  null
  
)

export default component.exports